import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-limit-reached-popup',
	templateUrl: './limit-reached-popup.component.html',
	styleUrls: ['./limit-reached-popup.component.scss']
})
export class LimitReachedPopupComponent implements OnInit {
	@Input() item: { name: string; type: string };
	@Input() itemsToDelete: any[];
	@Input() message: string;

	constructor(
		public activeModal: NgbActiveModal,
		private translateService: TranslateService,
		private router: Router
	) {}

	public errorMessage = '';
	ngOnInit() {
		this.errorMessage = this.translateService.instant(
			'You’ve hit the maximum allowed usage for this feature based on your current subscription plan. To continue using it, please upgrade your plan'
		);
	}

	upgrade(): void {
		this.activeModal.close();
		this.router.navigate(['admin/account/subscription']);
	}
}
